import type { MonospacePrimitiveFieldMeta, MonospaceSerializedPrimitiveField } from '#layers/data-model';
import { RStoreSchema } from '#imports';

interface StudioPrimitiveField extends MonospaceSerializedPrimitiveField {
	isStudioOnly?: boolean;
}

export const PrimitiveField = RStoreSchema.withItemType<StudioPrimitiveField>().defineCollection({
	name: 'MonospacePrimitiveField',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: ['id', 'dbName', 'apiName', 'type', 'defaultValue', 'isNullable', 'isList', 'isReadOnly', 'collectionId'],
		useProjectSlug: true,
	},
});

export const PrimitiveFieldMeta = RStoreSchema.withItemType<MonospacePrimitiveFieldMeta>().defineCollection({
	name: 'MonospacePrimitiveFieldMeta',
	scopeId: 'monospace-default',
	getKey: (item) => item.fieldId,
	meta: {
		defaultFields: ['fieldId', 'displayName', 'description', 'typeTemplateId', 'typeOptions', 'inputId', 'inputOptions', 'displayId', 'displayOptions', 'isHidden', 'sort'],
		useProjectSlug: true,
		connect: {
			fieldId: ['field', 'id'],
		},
	},
});
